import { ITenant } from '../../AbmLocalPage/types'
import { axiosInstanceMain } from './../../../utils/axiosGlobalUtils'

export const LoginService = async (user: { user: string; pwd: string; captcha: string }, tenant: ITenant) =>
  await axiosInstanceMain.post(`/${tenant.path}/auth/login`, user)
